export default "__VITE_ASSET__DgyTD$sW__"